export default __webpack_public_path__ + "static/media/compras_covid.2aa53f43.svg";